import { uiAmountToLamports } from "@bridgesplit/utils";

import { AbfLoanExpanded, Collateral, QuoteCollateralInfo } from "../types";
import { getAssetType } from "../utils";
import {
    getCollateralIdentifier,
    getCollateralMint,
    getLoanCollateralIdentifier,
    getLoanCollateralMint
} from "./loans";

// Used in refinance when metadata needs to be adjusted for the new format
export function getCollateralMintToInfo(
    loanExpanded: AbfLoanExpanded | undefined,
    additionalCollateralByMint?: Map<string, number>
): Map<string, QuoteCollateralInfo> | undefined {
    if (!loanExpanded) return undefined;

    const collateralMintToInfo = new Map<string, QuoteCollateralInfo>();
    const collateral = loanExpanded.collateral;

    collateral.forEach((c) => {
        const collateralMint = getLoanCollateralMint(c);
        const collateralIdentifier = getLoanCollateralIdentifier(c);
        if (!collateralMint || !collateralIdentifier) return;
        const amount = c.amount + (additionalCollateralByMint?.get(collateralMint) ?? 0);
        collateralMintToInfo.set(collateralMint, {
            amount: uiAmountToLamports(amount, c.metadata.decimals),
            assetType: getAssetType(c.metadata),
            assetMint: collateralMint,
            assetIdentifier: collateralIdentifier
        });
    });

    return collateralMintToInfo;
}

// Used for market borrow context, when generating quotes from a form
export function getCollateralMintToInfoFromForm(
    collateralMint: string | undefined | null,
    activeUserCollateral: Collateral | undefined,
    collateralAmount: number | undefined
): Map<string, QuoteCollateralInfo> | undefined {
    if (!collateralMint || !activeUserCollateral || !collateralAmount) return undefined;

    const assetMint = getCollateralMint(activeUserCollateral);
    const assetIdentifier = getCollateralIdentifier(activeUserCollateral);

    if (!assetMint || !assetIdentifier) return undefined;

    return new Map([
        [
            collateralMint,
            {
                amount: uiAmountToLamports(collateralAmount, activeUserCollateral.metadata.decimals),
                assetType: getAssetType(activeUserCollateral.metadata),
                assetMint: assetMint,
                assetIdentifier: assetIdentifier
            }
        ]
    ]);
}
